//MODEL: custom model object : { domain: instance of Domain }

define('app/dashboard/dialogs/SelectWidgetsDialogView',['require','glu/itemView','glu/collection','app/app','glu/util','glu/$','glu/grid'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView'),
		Collection = require('glu/collection'),
		APP = require('app/app'),
		_ = require('glu/util'),
		$ = require('glu/$'),
		Grid = require('glu/grid'),
		widgetTypes = {
			'KPI': 'KPI',
			'LINECHART': 'Line Chart',
			'DONUT': 'KPI',
			'BARCHART': ' Bar Chart',
			'PIECHART': 'Pie Chart',
			'STACKEDBARCHART': 'Funnel Chart',
			'SCATTERPLOT': 'Scatter Plot',
			'TOP10': 'Top 10'
		};

	var view = ItemView.extend({

		ui: {
			$searchTxt: '[name=searchTxt]',
			$selectColumnsContent: '.select-columns-content'
		},

		getClass: function() {
			return 'modal-add-widget';
		},

		dialogTitle: 'Select Widgets',

		events: {
			'keyup [name=filterData]': 'filterData',
			'click td[data-title]': 'selectRow'
		},

		dialogButtons: [{
			text: 'Add Widgets',
			callback: 'announceSelectedFields',
			className: 'btn-primary'
		}, {
			text: 'Clear',
			callback: 'clearCheckboxes',
			className: 'btn-link'
		}],

		initialize: function() {
			var self = this;

			this.collectionData = self.generateCollectionData();
			var columns = self.generateColumnsData();

			this.grid = new Grid({
				gridSearch: true,
				filter: true,
				paginate: false,
				collection: _.clone(this.collectionData),
				columns: columns,
				disableAuxControl: true,
				resizable: false,
				draggable: false,
				rowClassName: self.getRowClassName,
				defaultSort: {
					field: 'domain',
					order: 'asc'
				}
			});
		},

		getRowClassName: function(model) {
			return 'widget-name-' + model.get('name').toString().toLowerCase()
				.replace(/\s+/g, '-') // Replace spaces with -
				.replace(/[^\w\-]+/g, '') // Remove all non-word chars
				.replace(/\-\-+/g, '-') // Replace multiple - with single -
				.replace(/^-+/, '') // Trim - from start of text
				.replace(/-+$/, ''); // Trim - from end of text
		},

		filterData: function(e) {
			var data = _.clone(this.collectionData);

			this.grid.collection.reset(data.models.filter(function(widget) {
				return JSON.stringify(widget).toLowerCase().indexOf($(e.currentTarget).val().toLowerCase()) > -1;
			}));
		},

		generateCollectionData: function() {
			var widgets = [];
			APP.domains.each(function(d) {
				var domainWidgets = d.getWidgets();

				for (var i = 0; i < domainWidgets.length; i++) {
					domainWidgets[i].domain = d.get('name');
					domainWidgets[i].type = domainWidgets[i].visual.options.dashboardWidgetType;
					domainWidgets[i].formattedType = widgetTypes[domainWidgets[i].visual.options.dashboardWidgetType];
					widgets.push(domainWidgets[i]);
				}
			});

			return new Collection(widgets);
		},

		generateColumnsData: function() {
			return new Collection([{
				width: 50,
				label: '',
				filterable: false,
				sortable: false,
				type: 'rowSelector'
			}, {
				field: 'name',
				label: 'Name',
				title: 'Name',
				width: 200
			}, {
				field: 'formattedType',
				label: 'Type',
				title: 'Type',
				width: 110
			}, {
				field: 'description',
				label: 'Description',
				title: 'Description'
			}, {
				field: 'domain',
				label: 'Domain',
				title: 'Domain',
				width: 110
			}]);
		},

		render: function() {
			this.$el.append('<div class="search-wrap icon-search"><input type="text" name="filterData" id="filterData" class="form-control icon-search"></div>');
			this.$el.append(this.grid.render().el);

			// Filter tables only if a widget type exists
			switch (this.model.get('widgetType')) {
				case 'top-10':
					this.grid.collection.trigger('grid:filter:formattedType', 'Top 10');
					break;
				case 'chart':
					this.grid.collection.trigger('grid:filter:formattedType', 'Chart');
					break;
				case 'kpi':
					this.grid.collection.trigger('grid:filter:formattedType', 'KPI');
					break;
			}
		},

		announceSelectedFields: function() {
			var selectedRows = this.grid.getSelectedRowModels();
			var ids = [];

			for (var i = 0; i < selectedRows.length; i++) {
				ids.push(selectedRows[i].get('id'));
			}

			this.trigger('selectFields', ids);
		},

		clearCheckboxes: function() {
			// Cannot find an 'unselect' method in Glu?
			this.$el.find('.column-row-selector:checked').click();
			this.render();
		},

		selectRow: function(e) {
			$(e.currentTarget).parent().find('.column-row-selector').click();
		}
	});

	return view;
});

